// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__8JW2f","message":"Form_message__3zO3M"};